
import { Card, Col, Row, Typography } from "antd";
import { SocialLoginOptionsProps } from "apps/Account/Modesl";
import { getExternalLogin } from "apps/Account/Services";
import { FC } from "react";
import googleIcon from "assets/Images/google_icon.svg"
import appleIcon from "assets/Images/apple_icon.svg"
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const SocialLoginOptions:FC<SocialLoginOptionsProps> = (props) => {
  const { Text } = Typography;
  

  return (
    <>
      <Row gutter={[0, 10]}>
       
        <Col span={24} className=" hover:cursor-pointer">
          <Card bodyStyle={{ padding: "5px" }}>
            <Row>
              <Col xs={24} className="flex items-center justify-center gap-2 " onClick={()=>{
                if(props.loginType ==="email")
                {
                  props.setLoginType("phone")
                }
                else{
                  props.setLoginType("email")
                }
              }} >
                {
                  props.loginType ==="email"?<>
               
                   <Text className=" !text-black">Telefon İle Giriş Yap</Text>
                   
                  </>:<>
                 
                  <Text className=" !text-black">E-Posta İle Giriş Yap</Text>
                 
                  </>
                }
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24} className=" hover:cursor-pointer">
          <Card bodyStyle={{ padding: "5px" }}>
            <Row>
              <Col xs={24} className="flex items-center justify-center gap-2 " onClick={()=>{
                getExternalLogin("apple", window.location.origin+"/admin/panel")
              }} >
                <LazyLoadImage
                wrapperWidth="27px"
                wrapperHeight="27px"
                src={appleIcon}
                alt="apple"
                style={{objectFit:"fill"}}
                />
                  <a onClick={()=>{
                   props.setIsResetPassValidtion(true)
                    props.form.resetFields()
                  }} className="!text-black" href={`${setBackEndUlr()}/api/v1.0/Account/ExternalLogin?provider=apple&returnUrl=${setBackEndUlr("client")}/`} >Apple  İle Giriş Yap </a>

              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24} className=" hover:cursor-pointer ">
          <Card bodyStyle={{ padding: "5px", }}>
            <Row className="">
              <Col xs={24} className="flex items-center justify-center gap-2" >
                <LazyLoadImage
                wrapperWidth="20px"
                wrapperHeight="20px"
                src={googleIcon}
                alt="google"
                />
                {/* <Text className=" !text-black">Google  İle Giriş Yap </Text> */}
                <a
                 onClick={()=>{
                  props.setIsResetPassValidtion(true)
                  props.form.resetFields()
                }} 
                 className="!text-black" href={`${setBackEndUlr()}/api/v1.0/Account/ExternalLogin?provider=Google&returnUrl=${setBackEndUlr("client")}/`} >Google  İle Giriş Yap </a>
              </Col>
            </Row>
          </Card>
        </Col>
       
      </Row>
    </>
  );
};

export default SocialLoginOptions;
